/**
 * 元素 节点
 */
export const ELEMENT = 1

/**
 * 属性 节点
 */
export const ATTRIBUTE = 2

/**
 * 指令 节点
 */
export const DIRECTIVE = 3

/**
 * 属性 节点
 */
export const PROPERTY = 4

/**
 * 文本 节点
 */
export const TEXT = 5

/**
 * if 节点
 */
export const IF = 6

/**
 * else if 节点
 */
export const ELSE_IF = 7

/**
 * else 节点
 */
export const ELSE = 8

/**
 * each 节点
 */
export const EACH = 9

/**
 * partial 节点
 */
export const PARTIAL = 10

/**
 * import 节点
 */
export const IMPORT = 11

/**
 * 表达式 节点
 */
export const EXPRESSION = 12

/**
 * 延展操作 节点
 */
export const SPREAD = 13
